import Box from "@mui/material/Box"
import Link from "next/link"

import { Desktop } from "../components/device"
import AppLogo from "./app_logo"
import type { Styles, SxStyles } from "@/types/util"

const styles = {
  logos: {
    display: "flex",
    alignItems: "center",
    gap: "25px",
    fontSize: 0,
  },
} satisfies SxStyles

const linkStyle = {
  display: "block",
  height: "55px",
} satisfies Styles[string]

const AppHeaderSide1 = () => {
  return (
    <Box sx={styles.logos}>
      <Desktop>
        <Link rel="noopener noreferrer" href="/" style={linkStyle}>
          <AppLogo />
        </Link>
      </Desktop>
    </Box>
  )
}

export default AppHeaderSide1
